<script setup>
import {
  getCurrentInstance,
  ref,
  computed
} from 'vue'
import crewCard from '../components/crewCard.vue'
import SKcrewCard from '../components/skeletons/SKcrewCard.vue'
import CreateCrew from './CreateCrew.vue'
import { DriverStore } from '../pinia/Driver.js'

const Driver = DriverStore()
const {
  proxy
} = getCurrentInstance()

const inputsearch = ref("")
var crews = ref([])
const isLoading = ref(true)

function search(e) {
  inputsearch.value = e
}

callCards()

async function callCards() {
  isLoading.value = true
  const [res] = await Promise.all([
    proxy.$api({
      serviceName: "crew",
      methodName: "GetCards",
      parameters: []
    }),
    new Promise(resolve => setTimeout(resolve, 800))
  ])
  crews.value = res
  isLoading.value = false
}

const computedCrews = computed(() => {
  var tempCrew = crews.value

  if (inputsearch.value)
    return tempCrew.filter(i => i.name.toLowerCase().includes(inputsearch.value.toLowerCase()))
  else
    return crews.value
})

const showingMoulaPopup = ref(false)

function showMoulaPopup() {
  showingMoulaPopup.value = true
}
</script>
<template>
  <v-app-bar :elevation="2" class="modern-app-bar">
    <v-icon class="mr-3">mdi-account-group</v-icon>
    <div class="app-bar-content">
      <v-app-bar-title class="app-bar-main-title">Crews</v-app-bar-title>
      <div class="app-bar-subtitle">Join or create a racing team</div>
    </div>
    <v-spacer></v-spacer>
    <CreateCrew
      v-if="Driver.persona.boost >= 40000 && Driver.crew.can_join && Driver.persona.level >= 30 && Driver.persona.personaAge >= 30" />
    <v-btn prepend-icon="mdi-help-circle" variant="tonal"
      v-if="(Driver.persona.boost < 40000 || Driver.persona.level < 30 || Driver.persona.personaAge < 30) && Driver.crew.can_join"
      @click="showMoulaPopup">
      How to Create a Crew
    </v-btn>
    <v-btn :to="'/crew/headquarters/' + Driver.crew.current.id" prepend-icon="mdi-account-group" variant="tonal" v-if="(Driver.crew.can_join == false)">
      {{Driver.crew.current.name}}'s Crew Page
    </v-btn>
  </v-app-bar>

  <div class="d-flex" style="margin: 30px 30px 0px 30px; justify-content: center;align-items: center;">
    <v-text-field @update:model-value="search" style="flex:1;margin-right: 20px;" label="Search a crew"
      prepend-icon="mdi-magnify" variant="underlined"></v-text-field>
  </div>

  <transition name="fade" mode="out-in">
    <div v-if="isLoading" class="grid" key="skeleton">
      <SKcrewCard v-for="i in 12" :key="i" />
    </div>
    <div v-else class="grid" key="content">
      <crewCard :key="crew.crewid" :data="crew" v-for="crew in computedCrews" />
    </div>
  </transition>

  <v-dialog v-model="showingMoulaPopup" transition="dialog-bottom-transition" :width="500">
    <v-card>
      <v-toolbar dark color="primary" class="help-toolbar">
        <v-icon class="mr-2">mdi-help-circle</v-icon>
        <div class="toolbar-content">
          <v-toolbar-title class="toolbar-main-title">How to create a crew?</v-toolbar-title>
          <div class="toolbar-subtitle">Requirements and guidelines</div>
        </div>
      </v-toolbar>
      <v-card-text style="font-size: 14px;">
        In order to create a crew you have to fill all the conditions below.
      </v-card-text>
      <v-card-text style="font-size: 14px;">
        <v-icon v-if="Driver.persona.boost >= 40000" style="color:green">mdi-check-circle</v-icon><v-icon v-if="Driver.persona.boost < 40000" style="color:red">mdi-close-circle</v-icon> - Have minimum <b>40,000 SB</b> on your current driver wallet.
        <br>
        <v-icon v-if="Driver.persona.level >= 30" style="color:green">mdi-check-circle</v-icon><v-icon v-if="Driver.persona.level < 30" style="color:red">mdi-close-circle</v-icon> - Be at least <b>level 30</b> on your current driver.
        <br>
        <v-icon v-if="Driver.persona.personaAge >= 30" style="color:green">mdi-check-circle</v-icon><v-icon v-if="Driver.persona.personaAge < 30" style="color:red">mdi-close-circle</v-icon> - Your current driver profile must exist since at least <b>30 days</b>.
        <br>
        <br>
        <br>
        Once all these requirements are validated, you will see the button <b>CREATE CREW</b> in the top right corner of
        this page.
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<style scoped>
.grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  background: var(--secondary-color);
  margin-top: 20px;
}

/* Fade Transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* Toolbar Styles */
.help-toolbar {
  padding: 8px 16px !important;
}

.toolbar-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
}

.toolbar-main-title {
  font-size: 1.25rem !important;
  font-weight: 600 !important;
  line-height: 1.2 !important;
}

.toolbar-subtitle {
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1;
}
</style>
  